import { useMemo } from 'react';
import PaperCard from '../components/PaperCard';
import { useFavorites } from '../lib/useFavorites';

export default function FavoritesPage() {
  const { list } = useFavorites();

  // 按收藏时间降序（最新收藏在前；旧数据无 _fav_at 时排最后）
  const sorted = useMemo(() => {
    return [...list].sort((a, b) => (b._fav_at || 0) - (a._fav_at || 0));
  }, [list]);

  return (
    <div className="page-favorites">
      <header className="content-head">
        <h2>我的收藏</h2>
        <span className="content-sub">{list.length} 篇（按收藏时间降序）</span>
      </header>
      {sorted.length === 0 ? (
        <div className="empty-hint">
          <i className="far fa-star" style={{ fontSize: 32, opacity: 0.4, display: 'block', marginBottom: 10 }} />
          还没有收藏。在论文卡片上点击 ☆ 即可收藏。
        </div>
      ) : (
        <div className="card-grid">
          {sorted.map(p => <PaperCard key={p.id} paper={p} navIds={sorted.map(x => x.id)} />)}
        </div>
      )}
    </div>
  );
}
